/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-06 14:16:23
 * @LastEditTime: 2020-08-21 18:24:12
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/utils/request.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import axios from "axios";
import { getToken } from "@/utils/auth";
import Vue from "vue";
import { clearStore } from "@/utils/store";
import router from "../router";
import { loadingStart, loadingFinish } from "@/utils/loading";
import languages from "../store/modules/languages";
import { getStore } from '@/utils/store'

//  获取url参数  以#截取
function urlParams(url){
  let indexStart = url.indexOf('#')
  if(indexStart == -1){return {}}
  let k = url.slice(indexStart+1);
  let x = k.replace(/&/g,'","').replace(/=/g,'":"');
  let y = '{"'+x+'"}'
  return JSON.parse(y)
  
}
/**
 * 使用自定义配置新建一个 axios 实例
 * baseURL = 请求路径
 * timeout = 请求超时配置
 */
const request = axios.create({
  baseURL: process.env.BASE_API,
  // timeout: process.env.TIME_OUT
});

/**
 * request拦截器
 * 可以在这里添加 Header 头部信息，等
 */
request.interceptors.request.use(
  config => {
    let accessToken = getToken(); // 获取accessToken
    // 多语言
    let language = getStore({name: 'lang', type: true}) 
    config.headers["Accept-Language"] = !language?languages.state.currentLang.value: language.value; 

    if (config.url.indexOf("/sso/login") !== -1) {
      console.log("没有token!");
    }
     else {
      // 添加请求头信息，处理安全性问题
      config.headers.Authorization = "Bearer" + " " + accessToken;
    }
    // 添加时间戳防止IE不刷新页面
    if (
      config.method == "post" &&
      config.headers["Content-Type"] !== "multipart/form-data"
    ) {
      config.data = Array.isArray(config.data)
        ? [...config.data]
        : {
          ...config.data
          // _t: Date.parse(new Date()) / 1000,
        };
    } else if (config.method == "get") {
      config.params = {
        // _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }

    loadingStart();
    return config;
  },
  error => {
    console.log(error)
    // 处理请求错误
    Promise.reject(error);
  }
);

/**
 * 下面的注释为通过response自定义code来标示请求状态，当coBASE_APIde返回如下情况为权限有问题，登出并返回到登录页
 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
 */
request.interceptors.response.use(
  response => {
    // console.log("相应", response);
    loadingFinish();

    const res = response.data;
    /**
     * 根据后台的状态进行统一封装
     * 需看完api文档统一处理
     */
    if (
      response.status == 200 ||
      response.status == 201 ||
      response.status == 204
    ) {
      return res;
    } else {
      console.log(res);
      Vue.prototype.$message({ message: response.statusText, type: "error" });
      return Promise.reject(response);
    }
  },
  error => {
    loadingFinish();
    if (!error.response) {
      // 断网了
      Vue.prototype.$message({
        type: "error",
        message: Vue.prototype.$i18.tc("network.noNetWork")
      });
      return;
    }
    if (error.response.status == 401) {
      Vue.prototype.$message({
        type: "error",
        message: Vue.prototype.$i18.tc("network.permission")
      });
      //clearStore({ type: true });
      router.push("/login");
    } else if (error.response.status == 500) {
      Vue.prototype.$message({
        type: "error",
        message: Vue.prototype.$i18.tc("network.error")
      });
    } else if (error.response.status == 504) {
      Vue.prototype.$message({
        type: "error",
        message: Vue.prototype.$i18.tc("network.nowork")
      });
    } else if (error.response.status == 400) {
      console.log("400");
      sessionStorage.clear();
    } else {
      // Vue.prototype.$message({
      //   type: "error",
      //   message: Vue.prototype.$i18.tc("network.noNetWork")
      // });
    }
    return Promise.reject(error.response);
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js